import { http } from "@/utils/axios";

/**
 * @msg: 获取提问列表
 * params {params.oid} 课程id
 * params {params.UID} 当前用户id
 * http://gz.hnjk.net/zkfz/elZyQuestion/getQuestionPage?oid=911&page=1&pageSize=20&uid=1
 */
export function getQuestionList(data) {
    return http({
        url: http.baseUrl('elZyQuestion/getQuestionPage'),
        method: 'get',
        data,
        params: data
    })
}

/**
 * @msg: 审核通过 /zkfz/elZyQuestion/verifyQuestion?id=100&isVerify=1
 * params {params.id} 主键 id
 * params {params.isVerify} 通过状态 isVerify
 * http://gz.hnjk.net/zkfz/elZyQuestion/verifyQuestion?id=100&isVerify=1
 */
export function getVerifyQuestion(data) {
    return http({
        url: http.baseUrl('elZyQuestion/verifyQuestion'),
        method: 'get',
        data,
        params: data
    })
}

/**
 * @msg: 审核不通过 
 * params {params.id} 主键 id
 * params {params.isVerify} 通过状态 isVerify
 * params {params.nopassReason} 原因 nopassReason
 * http://gz.hnjk.net//zkfz/elZyQuestion/verifyQuestion?id=100&isVerify=2&nopassReason=test中国
 */
export function getNoVerifyQuestion(data) {
    return http({
        url: http.baseUrl('elZyQuestion/verifyQuestion'),
        method: 'get',
        data,
        params: data
    })
}

/**
 * @msg: 删除
 * params {params.ids} 主键 ids
 * http://gz.hnjk.net//zkfz/elZyQuestion/delQuestion?ids=100
 */
export function getdelQuestion(data) {
    return http({
        url: http.baseUrl('elZyQuestion/delQuestion'),
        method: 'get',
        data,
        params: data
    })
}

/**
 * @msg: 回复
 * params {params.parentId} 提问人id parentId
 * params {params.uid} 用户id uid
 * params {params.replyUid} 回复人id replyUid
 * params {params.oid} 课程id oid
 * params {params.qstDescription} 回复内容 qstDescription
 * params {params.batchId} 批次id batchId
 * http://gz.hnjk.net//zkfz/elZyQuestion/replyQuestion?parentId=100&replyUid=23095&uid=1&oid=878&isVerify=1&isOpen=1&qstDescription=zzzzz&batchId=c9371aefaeda4d78ab40031c58dcd64d
 */
export function getReplyQuestion(data) {
    return http({
        url: http.baseUrl('elZyQuestion/replyQuestion'),
        method: 'post',
        data,
        params: data
    })
}

/**
 * @msg: 置顶/取消置顶
 * params {params.id}  提问id
 * params {params.sort } 排序sort：999 取消置顶：0
 * http://gz.hnjk.net//zkfz/elZyQuestion/sortQuestion?id=153&sort=999
 */
export function getSortQuestion(data) {
    return http({
        url: http.baseUrl('elZyQuestion/sortQuestion'),
        method: 'get',
        data,
        params: data
    })
}